import { useLegend } from "hooks/legendHooks";

import { ExtendedWMSParams } from "types/types";

import { LegendItem } from "./LegendItem";

interface Props {
  id: number;
  url: string;
  wms: ExtendedWMSParams;
}

export function LegendData(props: Props) {
  const { url, wms, id } = props;

  const { data: legendData } = useLegend(url, wms);

  return (
    <>
      {legendData &&
        legendData.map((definition, i) => (
          <LegendItem
            definition={definition}
            key={`legend-data-${i}-${id || -1}`}
          />
        ))}
    </>
  );
}
